import { Button, Divider, Row, Select } from 'antd'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks'
import { getBrandList, getCaseStatusList } from '../../home/homeActions'
import { selectBrandOptions, selectCaseStatusOptions } from '../../home/homeSlice'
import { editSession } from '../../../app/services/session'
import IssueTagging from '../../IssueTagging/IssueTagging'
import { selectIsMcjeansEmployee } from '../../../hooks/auth/authReducer'

const SessionInfoForm = ({ id, session, on_save, parent_type, tagging_list, setTaggingList }) => {
    const dispatch = useAppDispatch()
    const brandOptions = useAppSelector(selectBrandOptions)
    const caseStatusOptions = useAppSelector(selectCaseStatusOptions)
    const isMcjeansEmployee = useAppSelector(selectIsMcjeansEmployee)

    const [selectedBrand, setSelectedBrand] = useState('')
    const [selectedCaseStatus, setSelectedCaseStatus] = useState('')
    const [isEditMode, setIsEditMode] = useState(false)

    // Map brand and case_status from session data when session changes
    useEffect(() => {
        console.log('session ', session)
        if (session?.brand) {
            setSelectedBrand(session.brand)
        }
        setSelectedCaseStatus(session?.case_status || '')
    }, [session])

    // Transform API response to {value, label} format
    const brand_options = brandOptions ? brandOptions.map(brand => ({
        value: brand,
        label: brand
    })) : []

    const case_status_options = caseStatusOptions ? caseStatusOptions.map(status => ({
        value: status,
        label: status
    })) : []

    useEffect(() => {
        dispatch(getBrandList())
        if (!isMcjeansEmployee) {
            dispatch(getCaseStatusList())
        }
    }, [])

    const handleChangeBrand = (value) => {
        setSelectedBrand(value)
    }

    const handleChangeCaseStatus = (value) => {
        setSelectedCaseStatus(value ?? '')
    }

    const handleClickEditMode = () => {
        setIsEditMode(true)
    }

    const handleSave = () => {
        const payload = {
            session_id: id,
            brand: selectedBrand
        }

        // Include case_status for non-McJeans employees
        if (!isMcjeansEmployee) {
            payload.case_status = selectedCaseStatus
        }

        dispatch(editSession(payload))
            .unwrap()
            .then(() => {
                setIsEditMode(false)

                // Save brand to localStorage for next time
                const savedPreferences = localStorage.getItem('create_session_preferences')
                let preferences = {}

                if (savedPreferences) {
                    try {
                        preferences = JSON.parse(savedPreferences)
                    } catch (error) {
                        console.error('Error parsing saved preferences:', error)
                    }
                }

                // Update only the brand field
                preferences.brand = selectedBrand
                localStorage.setItem('create_session_preferences', JSON.stringify(preferences))
            })
            .catch((error) => {
                console.error('Error saving:', error)
            })
    }

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* ข้อมูลพื้นฐาน Section */}
            <div style={{ flexShrink: 0 }}>
                {/* <Divider style={{ margin: '10px 0' }}><h3 style={{ margin: 0 }}>ข้อมูลพื้นฐาน</h3></Divider> */}
                <Row style={{ marginBottom: '10px', alignItems: 'center' }}>
                    <div style={{ marginRight: '10px' }}>แบรนด์:</div>
                    <Select
                        disabled={!isEditMode}
                        style={{ width: '200px' }}
                        options={brand_options}
                        value={selectedBrand}
                        onChange={handleChangeBrand}
                    />
                </Row>
                {!isMcjeansEmployee && (
                    <Row style={{ marginBottom: '10px', alignItems: 'center' }}>
                        <div style={{ marginRight: '10px' }}>สถานะเคส:</div>
                        <Select
                            disabled={!isEditMode}
                            style={{ width: '200px' }}
                            options={case_status_options}
                            value={selectedCaseStatus}
                            onChange={handleChangeCaseStatus}
                            allowClear
                        />
                    </Row>
                )}
                <Row style={{ marginBottom: '10px' }}>
                    {!isEditMode ? (
                        <Button type="primary" onClick={handleClickEditMode}>
                            แก้ไข
                        </Button>
                    ) : (
                        <Button type="primary" onClick={handleSave}>
                            บันทึก
                        </Button>
                    )}
                </Row>
            </div>

            {/* ข้อมูลเพิ่มเติม Section */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                <Divider style={{ margin: '10px 0' }}><h3 style={{ margin: 0 }}>ข้อมูลเพิ่มเติม</h3></Divider>
                <div style={{ flex: 1, minHeight: 0 }}>
                    <IssueTagging
                        id={id}
                        on_save={on_save}
                        parent_type={parent_type}
                        tagging_list={tagging_list}
                        setTaggingList={setTaggingList}
                    />
                </div>
            </div>
        </div>
    )
}

export default SessionInfoForm
